import { Component } from "react";
import { connect } from "react-redux";
import { BetSlipHelper } from "../../../../../../../../../../../helpers/betSlipHelper";
import { marketPeriodHelper } from "../../../../../../../../../../../helpers/marketPeriodHelper";
import type {
  EventMarketType,
  EventType,
} from "../../../../../../../../../../../types/eventType";
import { MarketTypes } from "../../../../../../../../../../../utils/const";
import RenderOddsComponent from "../RenderOddsComponent/RenderOddsComponent";
import "./PlayerPropRunner.scss";

type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  addBetSlip: (...args: Array<any>) => any;
};

class PlayerPropRunner extends Component<Props> {
  // when odds are clicked we add selection to the betslip
  addBetSlip = (runner: Record<string, any>) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };

  render() {
    const { event, market, marketType } = this.props;
    return (
      <div
        className={`player-props-runner market binary ${market.status.toLowerCase()}`}
      >
        {/* Display market name once */}
        <div className="playerpropName">{market.tags.PLAYER_NAME}</div>

        {market.runners.map(runner => {
          const handicap =
            market.marketInternalType &&
            market.marketInternalType.includes(MarketTypes.TOTAL) &&
            runner.modalFormattedHandicap
              ? runner.modalFormattedHandicap.replace(/\+/g, "")
              : market.formattedHandicap ||
                runner.modalFormattedHandicap ||
                runner.handicap;

          if (marketPeriodHelper.shouldHideRunner(runner)) {
            return (
              <span
                key={"binary" + runner.id}
                className={"binary-market__runner--empty"}
              ></span>
            );
          }

          return (
            <span
              key={"binary" + runner.id}
              onClick={() => {
                this.addBetSlip(runner);
              }}
              className="side-by-side player-props-runner__runner"
            >
              {handicap && (
                <div
                  className={`runner__name ${
                    market.formattedHandicap && "handicap"
                  }`}
                >
                  {handicap}
                </div>
              )}
              <RenderOddsComponent
                event={event}
                runner={runner}
                marketType={marketType}
              />
            </span>
          );
        })}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(null, mapDispatchToProps)(PlayerPropRunner) as any;
